import { useTranslation } from 'react-i18next';

export default function AboutAurion() {
  const { t } = useTranslation();

  return (
    <section id="aurion" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              {t('about.titulo')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('about.subtitulo')}
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-lg">
            <div className="text-lg text-gray-700 leading-relaxed space-y-6">
              <p>
                {t('about.descripcion')}
              </p>

              <div className="grid md:grid-cols-4 gap-8 mt-12">
                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-calendar-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-teal-600 mb-1">+15</h3>
                  <p className="text-gray-600 text-sm">{t('about.experiencia')}</p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-building-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-teal-600 mb-1">+200</h3>
                  <p className="text-gray-600 text-sm">{t('about.proyectos')}</p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-flashlight-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-teal-600 mb-1">+50</h3>
                  <p className="text-gray-600 text-sm">{t('about.mwInstalados')}</p>
                </div>

                <div className="text-center">
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-emotion-happy-line text-2xl text-teal-600"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-teal-600 mb-1">98%</h3>
                  <p className="text-gray-600 text-sm">{t('about.satisfaccion')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
